export default __webpack_public_path__ + "static/media/830.daa90803.jpg";